import React from "react";
import PropTypes from "prop-types";
import { Field, ProgressBar, makeStyles } from "@fluentui/react-components";
import { Modal } from "./Modal";

const useStyles = makeStyles({
  root: {
    gap: "10px"
  },
  content: {
    minHeight: "auto",
    padding: "0px"
  }
});

export function ProgressDialog({ message, onConfirm, cancelable, onCancel, ...props }) {
  const styles = useStyles();
  return (
    <Modal contentClassName={styles.content} onClose={cancelable ? onCancel : null} {...props}>
      <Field validationMessage={message} validationState="none">
        <ProgressBar thickness="large" />
      </Field>
    </Modal>
  );
}

ProgressDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  cancelable: PropTypes.bool,
  cancelLabel: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
};

ProgressDialog.defaultProps = {
  title: "Loading...",
  cancelable: false,
  cancelLabel: "Cancel"
};

export default ProgressDialog;
